import OfferApi from "api/offer/offerApi";
import * as actionTypes from "../../actionTypes";
import * as financedChartActions from "features/offer/edit/decision/financedChart/actionTypes";
import * as eventTypes from "../../eventTypes";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "../httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadOfferDecisionSelectedConditions(documentId, siteId) {
  return async (dispatch, getState) => {
    let selectedConditions = getState().currentOffer.decision.selectedConditions;
    if (selectedConditions.isLoaded) {
      return;
    }

    try {
      selectedConditions = await dispatch(
        sendHttpRequest(OfferApi.loadOfferDecisionSelectedConditions(documentId, siteId))
      );
      dispatch({ type: actionTypes.LOAD_OFFER_DECISION_SELECTED_CONDITIONS_SUCCESS, payload: selectedConditions });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferDecisionAvailableConditions() {
  return async (dispatch, getState) => {
    let availableConditions = getState().currentOffer.decision.availableConditions;

    if (availableConditions.isLoaded) {
      return availableConditions;
    }

    try {
      availableConditions = await dispatch(sendHttpRequest(OfferApi.loadOfferDecisionAvailableConditions()));
      dispatch({ type: actionTypes.LOAD_OFFER_DECISION_AVAILABLE_CONDITIONS_SUCCESS, payload: availableConditions });

      return availableConditions;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferDecisionSelectedConditions(documentId, siteId, decisionSelectedConditions) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          OfferApi.updateOfferDecisionSelectedConditions(documentId, siteId, decisionSelectedConditions),
          "UpdateOfferDecisionConditionsInProgress",
          [eventTypes.OFFER_DECISION_SELECTED_CONDITIONS_UPDATED]
        )
      );

      if (event.ok) {
        dispatch({
          type: actionTypes.UPDATE_OFFER_DECISION_SELECTED_CONDITIONS_SUCCESS,
          payload: decisionSelectedConditions
        });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferDecisionFinancedAssets(documentId, siteId) {
  return async (dispatch, getState) => {
    let financedAssets = getState().currentOffer.decision.financedAssets;
    if (financedAssets.isLoaded) return;

    try {
      financedAssets = await dispatch(sendHttpRequest(OfferApi.loadFinancedAssets(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_OFFER_DECISION_FINANCED_ASSETS_SUCCESS, payload: financedAssets });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferDecisionFinancedChart(documentId, siteId) {
  return async (dispatch, getState) => {
    const financedChartFlags = getState().document.decision.financedChart[`${documentId}-${siteId}`] || {
      isLoaded: false,
      loading: false
    };
    if (financedChartFlags.isLoaded || financedChartFlags.loading) {
      return;
    }

    dispatch({
      type: financedChartActions.LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_STARTED,
      payload: { documentId, siteId }
    });

    try {
      const financedChart = await dispatch(sendHttpRequest(OfferApi.loadFinancedChart(documentId, siteId)));
      dispatch({
        type: financedChartActions.LOAD_OFFER_DECISION_FINANCED_ASSETS_CHART_SUCCESS,
        payload: { data: financedChart, documentId, siteId }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferDecisionSubsequentConditions(documentId, siteId) {
  return async (dispatch, getState) => {
    let subsequentConditions = getState().currentOffer.decision.subsequentConditions;

    if (subsequentConditions.isLoaded) {
      return;
    }

    try {
      subsequentConditions = await dispatch(
        sendHttpRequest(OfferApi.loadDecisionSubsequentConditions(documentId, siteId))
      );
      dispatch({ type: actionTypes.LOAD_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS, payload: subsequentConditions });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferDecisionSubsequentConditions(documentId, siteId, subsequentConditions) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          OfferApi.updateOfferDecisionSubsequentConditions(documentId, siteId, subsequentConditions),
          "UpdateOfferDecisionSubsequentConditionsInProgress",
          [eventTypes.OFFER_DECISION_SUBSEQUENT_CONDITIONS_UPDATED]
        )
      );

      if (event.ok) {
        dispatch({
          type: actionTypes.UPDATE_OFFER_DECISION_SUBSEQUENT_CONDITIONS_SUCCESS,
          payload: event.eventBody.subsequentConditions
        });
      }
      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
